(() => {
  const selector = '[role="dialog"][data-kl-scroll-locking-modal="true"]';
  const dismissed = new WeakSet();
  const closing = new WeakMap();

  function release(dialog, animation) {
    if (!dialog.isConnected || closing.get(dialog) !== animation ||
      animation.playState !== 'finished' || !dialog.getAnimations().includes(animation) ||
      getComputedStyle(dialog).opacity !== '0') return;

    dialog.inert = true;
    dialog.style.pointerEvents = 'none';
    dismissed.add(dialog);

    const active = [...document.querySelectorAll(selector)].some(popup => {
      const style = getComputedStyle(popup);
      return !dismissed.has(popup) && style.display !== 'none' && style.visibility !== 'hidden';
    });
    if (!active) document.body.classList.remove('klaviyo-prevent-body-scrolling');
  }

  function watch(dialog) {
    const animation = dialog.getAnimations().find(item => item.animationName === 'klaviyo-fadeout');
    if (!animation || closing.get(dialog) === animation) return;
    closing.set(dialog, animation);
    animation.finished.then(() => release(dialog, animation), () => {});
  }

  document.addEventListener('animationstart', event => {
    const dialog = event.target;
    if (!dialog.matches?.(selector)) return;
    if (event.animationName === 'klaviyo-fadein') {
      closing.delete(dialog);
      if (dismissed.delete(dialog)) {
        dialog.inert = false;
        dialog.style.removeProperty('pointer-events');
      }
    } else if (event.animationName === 'klaviyo-fadeout') {
      watch(dialog);
    }
  }, true);

  document.querySelectorAll(selector).forEach(watch);
})();
